const moment = require('moment-timezone');

/**
  * @function evalute - evaluate latestAuditTrailEntriesBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator) => {
  let groupBy = await sourceEvaluator(source.groupBy);
  if (groupBy === undefined) {
    groupBy = 'breadcrumbs';
  }
  const auditTrail = await sourceEvaluator(source.entries);
  if (auditTrail === undefined) {
    return undefined;
  }
  const minimumDate = '0001-01-01T00:00:00.0Z';
  const latestAuditTrailEntries = Object.keys(auditTrail).reduce((acc, key) => {
    const auditTrailEntry = auditTrail[key];

    // save the audit trail entry id so the entry can be reformatted
    // into the original audit trail form keyed by id
    auditTrailEntry.id = key;
    const element = auditTrailEntry[groupBy];
    if (element === undefined) {
      return acc;
    }
    let latestCreatedDate = minimumDate;
    /* eslint-disable-next-line no-underscore-dangle */
    const auditTrailEntryCreatedDate = auditTrailEntry._created || undefined;
    if (acc[element]) {
      /* eslint-disable-next-line no-underscore-dangle */
      latestCreatedDate = acc[element]._created || undefined;
    }
    if (latestCreatedDate === undefined || auditTrailEntryCreatedDate === undefined) {
      return acc;
    }
    const latestCreatedDateMoment = moment(new Date(latestCreatedDate));
    const auditTrailEntryCreatedDateMoment = moment(new Date(auditTrailEntryCreatedDate));
    if (latestCreatedDateMoment.isSameOrBefore(auditTrailEntryCreatedDateMoment)) {
      acc[element] = auditTrailEntry;
    }
    return acc;
  }, {});

  // reformat the audit trail entries so they are keyed by the original id
  let reformattedAuditTrail;
  Object.keys(latestAuditTrailEntries).forEach(key => {
    const auditEntry = latestAuditTrailEntries[key];
    const auditEntryId = auditEntry.id;
    delete auditEntry.id;
    if (reformattedAuditTrail === undefined) {
      reformattedAuditTrail = {};
    }
    reformattedAuditTrail[auditEntryId] = auditEntry;
  });
  return reformattedAuditTrail;
};
module.exports = {
  evaluate
};